export const PRODUCT_CATEGORIES = [
  { value: 'all', label: 'All Products' },
  { value: 'chairs', label: 'Chairs' },
  { value: 'tables', label: 'Tables' },
  { value: 'tents', label: 'Tents' },
  { value: 'packages', label: 'Packages' },
  { value: 'accessories', label: 'Accessories' }
];

export const CategoryFilter = ({ categories, activeFilter, onFilterChange }) => (
  <section className="sticky top-20 bg-white border-b z-40">
    <div className="max-w-7xl mx-auto px-4 py-4">
      <div className="flex gap-2 overflow-x-auto pb-2">
        {categories.map(cat => (
          <button
            key={cat.value}
            onClick={() => onFilterChange(cat.value)}
            className={`px-6 py-2 rounded-full font-medium whitespace-nowrap transition-colors ${
              activeFilter === cat.value 
                ? 'bg-celebration-red text-white' 
                : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
            }`}
            data-testid={`filter-${cat.value}`}
          >
            {cat.label}
          </button>
        ))}
      </div>
    </div>
  </section>
);
